import { defineMessages } from 'react-intl';

const messages = defineMessages({
    clearButton: {
        id: 'FloatingSearch.clearButton.text',
        defaultMessage: 'Clear',
        description: 'Text of the button to clear the FloatingSearch',
    },
});

export default messages;
